import Cookies from 'universal-cookie';
import env from '../env';
import {
  LOCAL_STORAGE_KEY_ACCESS_TOKEN,
  getLocalStorage,
  removeLocalStorage,
  setLocalStorage,
} from './localStorage';

/*
 * Fonte única do token de acesso.
 *
 * O token é gravado em cookie (compartilhado entre os subdomínios) e em
 * localStorage (fallback quando o cookie não pode ser gravado, como em
 * localhost). Manter as duas escritas e a leitura em um só lugar evita que uma
 * das pontas fique com um token defasado — o que derrubava a sessão quando o
 * token antigo sobrescrevia o recém-emitido.
 */

const cookieJar = () =>
  new Cookies(null, { path: '/', domain: env.REACT_APP_COOKIE_DOMAIN });

export const getAuthToken = (): string => {
  const cookieToken = cookieJar().get(env.REACT_APP_COOKIE_NAME);

  return cookieToken || getLocalStorage(LOCAL_STORAGE_KEY_ACCESS_TOKEN) || '';
};

export const setAuthToken = (token: string): void => {
  if (!token) return;

  cookieJar().set(env.REACT_APP_COOKIE_NAME, token);
  setLocalStorage(LOCAL_STORAGE_KEY_ACCESS_TOKEN, token);
};

export const clearAuthToken = (): void => {
  cookieJar().remove(env.REACT_APP_COOKIE_NAME);
  removeLocalStorage(LOCAL_STORAGE_KEY_ACCESS_TOKEN);
};
